<label *ngIf="label" class="rich-text-label">{{ label }}</label>
<div #editor></div>
<vdr-context-menu [editorMenuElement]="menuElement"></vdr-context-menu>
